/* eslint-disable react/jsx-sort-props */
import * as React from 'react';
import * as vars from '../../styles/variables';
import AccessibleSVG, { SVGProps } from '../../components/accessible-svg/AccessibleSVG';

/**
 * This is an auto-generated component and should not be edited
 * manually in contributor pull requests.
 *
 * If you have problems with this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Bug_report.md
 *
 * If there are missing features in this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Feature_request.md
 */

const FileZip16 = (props: SVGProps) => (
    <AccessibleSVG width={16} height={16} viewBox="0 0 16 16" {...props}>
        <path
            fill={vars.bdlGray50}
            fillRule="evenodd"
            d="M9.422 1c.146 0 .286.057.389.158l3.528 3.454a.53.53 0 01.161.38v8.393c0 .892-.74 1.615-1.65 1.615h-7.7c-.911 0-1.65-.723-1.65-1.615V2.615C2.5 1.723 3.239 1 4.15 1h5.272zM6 12H5v1h1v-1zm1-1H6v1h1v-1zm-1-1H5v1h1v-1zm1-1H6v1h1V9zM6 8H5v1h1V8zm1-1H6v1h1V7zM6 6H5v1h1V6zm1-1H6v1h1V5zM6 4H5v1h1V4z"
        />
    </AccessibleSVG>
);

export default FileZip16;
